// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__k_xfa","largestCol":"styles_largestCol__2osmf","smallestCol":"styles_smallestCol__3OqP_"};